// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"6724e822","76":"073fe387","154":"b3974dbb","214":"751d7a9f","260":"b2e13222","493":"c1f42160","524":"c79a2665","535":"8fc6d3dc","544":"5ce7c366","879":"9226e149","887":"8c019b74"}[chunkId] + ".chunk.js";
};